import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TagFacesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tag_faces"}/>
}
